var o = Object.defineProperty;
var l = (t, s, e) => s in t ? o(t, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[s] = e;
var i = (t, s, e) => l(t, typeof s != "symbol" ? s + "" : s, e);
class h extends Error {
  constructor(e) {
    super(e.detail);
    i(this, "errors");
    this.errors = e, this.violationsTitleToMessage();
  }
  // TODO: delete this method after BE decide what to use title or message
  violationsTitleToMessage() {
    var e;
    (e = this.errors.violations) == null || e.forEach((r) => {
      "title" in r && (r.message = r.title, delete r.title);
    });
  }
}
export {
  h as ErrorWithViolations
};
